import {apiConfig} from "./apiConfig";
import { slotsDate,slotIn } from "./refreshScheduleData";
import { daysInMonth } from "./daysInMonth";
import { schedulerState } from "./calendar";

export const defaultEnableCal = {
    enable: true,
    changeActive:false,
}
export function dateDisplay(count:any){
    var slotRows=[];
    var datesArray=[];
    //if((slotsByDate.length - count)<5){
   let loopCount = 5;
   if(slotsDate.slotsByDate.length < 5){
      loopCount = slotsDate.slotsByDate.length;
      if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
          $('.calendar-wrapper .next-btn').addClass('hidden');
      }
   }
   for(var i=0+count;i<loopCount+count;i++){
       if(i>=slotsDate.slotsByDate.length){
           var dateArray =  slotsDate.slotsByDate[slotsDate.slotsByDate.length-1].date.split('-');
           var mm = dateArray[1];
           var dd = parseInt(dateArray[2]);
           var yyyy = dateArray[0]
           var datesInMonth  = daysInMonth(mm,yyyy);
           if(dd == datesInMonth){
               dd = 1;
               mm = parseInt(dateArray[1])+1;
           }else{
               dd = dd + 1;
           }
           if (window.objOSGlobal.requestBodyValues.ConceptId != '25'){
               var dateUrl = mm+'/'+dd+'/'+yyyy;
                nextPrevDatesValues(new Date().getFullYear(), new Date().getMonth(),dateUrl,function(){
                    var finalData = slotsDate.slotsByDate.length - count;
                    if(finalData >0){
                        lastUpdateData(count,finalData);
                        return;
                    }
                });
           }else{
                 $('.calendar-wrapper .next-btn').addClass('hidden');
           }
           return;
        }
       var stringDate = slotsDate.slotsByDate[i].date;
       var monthName = new Date(stringDate.replace(/-/g, '\/').replace(/T.+/, '')).toLocaleString("default", { month: "short" });
       var weeks = new Date(stringDate.replace(/-/g, '\/').replace(/T.+/, '')).toLocaleDateString('en-US', { weekday: 'short' });
       var dates = new Date(stringDate.replace(/-/g, '\/').replace(/T.+/, '')).getDate()
       var allAvailable = slotsDate.slotsByDate[i].slots.reduce((a:any,b:any)=>a||b.isAvailable,false);
       datesArray.push(generateDateBlock(monthName, dates, weeks,i,allAvailable));
       var temp:any = [];
       slotsDate.slotsByDate[i].slots.forEach((element:any) => {
           temp.push(generateSlotButtonBlock(element.displayText, !element.isAvailable,{ monthName, weeks, dates},element));
       });
       slotRows.push(generateSlotRows(temp,i));
   }
   $('.date-details-wrapper').html(datesArray.join(''));
   $('.calendar-row').html(slotRows.join(''));
}
function nextPrevDatesValues(year:any,month:any,dateForUrl:any,callback:any){
    var isEstimate = localStorage.getItem("selectedAboutHome") == "recurring" ? "true" : "false"
    var isSchedule = window.location.href.toLowerCase().indexOf("molly-maid") != -1 ? "&IsEstimate="+isEstimate : "";
    var webLocationId = window.objOSGlobal.requestBodyValues.WebLocationId ? window.objOSGlobal.requestBodyValues.WebLocationId : '8113';
    var serviceSkuId = window.objOSGlobal.requestBodyValues.serviceSkuId
    var getZipCode = localStorage.getItem('zipcode');
    var zipCode = getZipCode ? getZipCode : 43230;
    var date = new Date();
    date = new Date(date.getFullYear(), date.getMonth(), 1);
    var numberOfDays = 31;
    if (year == date.getFullYear() && month == (date.getMonth() + 1)){
        numberOfDays = daysInMonth(month, year);
    } else {
        numberOfDays = daysInMonth(month, year);
    }
    $.ajax({
       url:apiConfig.techAvailability + '?PostalCode='+zipCode+'&WebLocationId='+webLocationId+'&NumberOfDays='+numberOfDays+'&ServiceSkuId='+serviceSkuId+'&DateStart='+dateForUrl+isSchedule+'&apikey='+window.DEFINE_VALUE.JS_API_KEY,
       type: "GET",
       contentType: "application/json",
       dataType: 'json',
       success: function (results) {
        if(results.resultCollection.length !=0){
            results.resultCollection.forEach((element:any) => {
                var date = element.startDate.split('T')[0]
                var item = slotsDate.slotsByDate.find((itm:any)=>itm.date==date);
                if(!item){
                item = {date,slots:[]}
                slotsDate.slotsByDate.push(item);
                }
                item.slots.push(element)
            });
            dateDisplay(slotIn.slotIndex);
        }else{
         callback();
        }
       },
       error: function (data) {
       }
   });
}
function lastUpdateData(count:any,finalData:any){
    var slotRows=[];
    var datesArray=[];
    for(var i=0+count;i<finalData+count;i++){
        var stringDate = slotsDate.slotsByDate[i].date;
        var monthName = new Date(stringDate).toLocaleString("default", { month: "short" });
        var weeks = new Date(stringDate).toLocaleDateString('en-US', { weekday: 'short' });
        var dates = new Date(stringDate).getDate();
        var allAvailable = slotsDate.slotsByDate[i].slots.reduce((a:any,b:any)=>a||b.isAvailable,false);
        datesArray.push(generateDateBlock(monthName, dates, weeks,i,allAvailable));
        var temp:any = [];
        slotsDate.slotsByDate[i].slots.forEach((element:any) => {
            temp.push(generateSlotButtonBlock(element.displayText, !element.isAvailable,{ monthName, weeks, dates},element));
        });
        slotRows.push(generateSlotRows(temp,i));
    }
    $('.date-details-wrapper').html(datesArray.join(''));
    $('.calendar-row').html(slotRows.join(''));
}


function generateDateBlock(month:any, date:any, week:any, id:any, isactive:any){
        var activecls = "";
        if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
            let activeButton = defaultEnableCal.changeActive ? false : isactive;
            if (activeButton)
            {
                activecls = 'active';
                defaultEnableCal.changeActive = true;
        
            }
        }else{
            if(isactive){
                activecls = 'active';
            }
        }
        return '<button class="date-details ' + activecls + '" data-index="id' + id + '">' +
            '<strong class="body-text-sm">' + month + ' <span>' + date + '</span></strong>' +
            '<span class="body-text-sm">' + week + '</span>' +
            '</button>'
}
function generateSlotButtonBlock(btnText:any, isDisable:any, obj:any, dt:any){
    var modifiedTime = btnText;    
    var displayTime = obj.weeks + ', ' + obj.monthName + ' ' + obj.dates + ' ' + (isDisable ? 'Unavailable' : 'at ' + modifiedTime);
    if (window.objOSGlobal.requestBodyValues.ConceptId == '25'){
        if (defaultEnableCal.enable && !isDisable)
        {
            defaultEnableCal.enable = false;
            $('.calendar-screen .next').removeClass('disble-btn').prop('disabled', false);
            sessionStorage.setItem('CTime', modifiedTime);
            $('.selected-date-txt').text(displayTime);
            window.objOSGlobal.requestBodyValues.selectedDate  = dt.startDate;
            window.objOSGlobal.requestBodyValues.ScheduleId = dt.scheduleID;
            schedulerState.selectedDate = dt.startDate;
            sessionStorage.setItem('selected-calendar-date', displayTime);
            $('.selected-date').removeClass('hidden');
            return '<button  data-scheduleId="' + dt.scheduleID + '" data-selectedDate="' + dt.startDate + '" data-time="' + displayTime + '"  class="calendar-btn active-cal active' + (isDisable ? 'disble-btn' : '') + '" ' + (isDisable ? 'disabled' : '') + '>' + (isDisable ? 'Unavailable' : modifiedTime) + '</button>'
        } else
        {
            return '<button  data-scheduleId="' + dt.scheduleID + '" data-selectedDate="' + dt.startDate + '" data-time="' + displayTime + '"  class="calendar-btn ' + (isDisable ? 'disble-btn' : '') + '" ' + (isDisable ? 'disabled' : '') + '>' + (isDisable ? 'Unavailable' : modifiedTime) + '</button>'
        }
    } else
    {
        return '<button  data-scheduleId="' + dt.scheduleID + '" data-selectedDate="' + dt.startDate + '" data-time="' + displayTime + '"  class="calendar-btn ' + (isDisable ? 'disble-btn' : '') + '" ' + (isDisable ? 'disabled' : '') + '>' + (isDisable ? 'Unavailable' : modifiedTime) + '</button>'
    }
}
function generateSlotRows(btnArray:any,colId:any){
    return '<div class="calendar-col" id="id'+colId+'">'+btnArray.join('')+'</div>';
}